import SocialStatsSummary from './SocialStatsSummary';

export default SocialStatsSummary;
